const { DEV, VITE_ENVIRONMENT } = import.meta.env;

export const getApiHost = (): string => {
  if (DEV) {
    const { host } = window.location;
    return `${host}`;
  }
  if (VITE_ENVIRONMENT === "staging") {
    return "widget.volumental.dev";
  }
  return "widget.volumental.com";
};

export const getAuthApiHost = (): string => {
  if (DEV) {
    return "127.0.0.1:3000";
  }
  if (VITE_ENVIRONMENT === "staging") {
    return "id.volumental.dev";
  }
  return "id.volumental.com";
};

export const getAuthApiURL = (): string => {
  const protocol = DEV ? "http" : "https";
  return `${protocol}://${getAuthApiHost()}/`;
};

export const getAuthAppURL = (): string => {
  if (DEV) {
    return "http://127.0.0.1:5100/";
  }
  if (VITE_ENVIRONMENT === "staging") {
    return "https://accounts.volumental.dev/";
  }
  return "https://accounts.volumental.com/";
};

// getApiURL is a function that returns the api path based on the environment.
export const getApiURL = (): string => `https://${getApiHost()}/query`;

// getApiURL is a function that returns the api path based on the environment.
export const getWsApiURL = (): string => `wss://${getApiHost()}/query`;
